import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 */
export class ResultPublishDraftValueObject extends ValueObject {
  /**
   * @param {String} resultCode
   */

  getResultCode() {
    return this._resultCode
  }
}
